module.exports = __webpack_public_path__ + "img/exposicaoPermanenteAzul.668e0dc0.svg";